// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3442":"4d6b1e618289a039","4241":"fac230b766638f92","5214":"e9d470320cf4e142","5596":"fc705152bdcb41a0"}[chunkId] + ".css";
};